import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import debounce from 'debounce'
import * as Sentry from '@sentry/vue'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import constants from '@/constant/index'

// api
import PresentationApi from '@/api/presentation'
import { ROUTE_NAMES } from '@/constant/routes'

const maxLengthHeading = 150

export default (SettingAudienceAdmission) => Vue.component('SettingAudienceAdmissionContainer', {
  data() {
    return {
      allFields: [],
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
    }),
  },
  created() {
    Object.keys(constants.audienceAdmissionFields).forEach((item) => {
      this.allFields.push(item)
    })
    if (!this.presentation.audienceAdmission) {
      this.presentation.audienceAdmission = {
        fields: [],
        isAudienceAdmission: false,
      }
    }
  },
  methods: {
    ...mapActions(['setSyncLoadingAction', 'setPresentationAction']),
    async handleCheckBoxAudienceAdmission() {
      await this.updateAdditionalFields()
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Settings menu > Audience admission > Audience admission checkbox',
        `Audience Admission: ${this.presentation.audienceAdmission.isAudienceAdmission}`,
      )
    },
    async updateAdditionalFields() {
      try {
        this.setSyncLoadingAction(1)
        await PresentationApi.updatePresentationByPresentationId(this.presentation.id, {
          audienceAdmission: this.presentation.audienceAdmission,
        })
        this.setPresentationAction(this.presentation)
        this.setSyncLoadingAction(2)
      } catch (error) {
        Sentry.captureException(error)
        this.setSyncLoadingAction(3)
        Sentry.captureException('Update Presentation audienceAdmission failed', error)
      }
    },
    handleOnInput: debounce(function onInputFunction(value) {
      if (value.length <= maxLengthHeading) {
        this.presentation.audienceAdmission.heading = value
        this.updateAdditionalFields()
      }
    }, 400),
    showResultsMenu() {
      this.$router.push({
        name: ROUTE_NAMES.PRESENTATION_REPORT,
        params: {
          id: this.presentation.id,
        },
      })
    },
  },
  render(createElement) {
    // add  emit
    return createElement(SettingAudienceAdmission, {
      props: {
        clickForUserNotPaid: () => this.$emit('open-when-user-not-paid'),
        handleCheckBoxAudienceAdmission: this.handleCheckBoxAudienceAdmission,
        allFields: this.allFields,
        updateAdditionalFields: this.updateAdditionalFields,
        handleOnInput: this.handleOnInput,
        showResultsMenu: this.showResultsMenu,
      },
    })
  },
})
